/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import type ContactAdministratorPageType from '@jira/admin-pages__contact-administrator/src/ContactAdministratorPage.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

export const LazyContactAdministratorPage: LazyComponent<typeof ContactAdministratorPageType> =
	lazyForPaint<typeof ContactAdministratorPageType>(() =>
		markAsProductBundleReady(
			import(
				/* webpackChunkName: "async-jira-admin-pages-contact-administrator", jiraSpaEntry: "async-jira-admin-pages-contact-administrator" */ '@jira/admin-pages__contact-administrator/src/ContactAdministratorPage.tsx'
			),
		),
	);

const AsyncContactAdministratorPage = (): React.JSX.Element => (
	<LazyPage
		Page={LazyContactAdministratorPage}
		pageId="jira-admin-pages-contact-administrator"
		shouldShowSpinner
	/>
);

export default AsyncContactAdministratorPage;
